module.exports = __webpack_public_path__ + "img/swiper2_d.ca7b560d.png";